import React, { useEffect, useState} from 'react';
import Client from '../utils/network';
import Button from './UI/Button';


const ImageSelector = ({ type, onSelect, onDelete, className, imageClassName, imageRefreshKey }: {
    type: string,
    onSelect: (string: string) => void
    onDelete?: (string: string) => void,
    className?: string
    imageClassName?: string
    imageRefreshKey: string
}) => {
    const [ images, setImages ] = useState<string[]>([]);

    const refreshImages = () => {
        Client.request(`/api/image/thumbnails/${type}`).then(async (res) => {
            const img = await res.json() as string[];
            setImages(img);
            return;
        }).catch(() => {
            // do nothing
        });
    };
    useEffect(() => {
        refreshImages();
    }, [imageRefreshKey]);
    return (
        <>
            <div className={className}>
                {
                    images.map((key) => {
                        return (
                            <div key={key} className='bg-back-blue w-fit p-2 rounded-lg'>
                                <img
                                    className={imageClassName}
                                    src={`${Client.getBaseUrl()}/api/image/${key}/thumbnail`}
                                    onClick={() => onSelect(key)}
                                />
                                {onDelete && (
                                    <Button onClick={() => onDelete(key)}>
                                        Delete
                                    </Button>
                                )}
                            </div>
                        );
                    })
                }
            </div>
        </>
    );
};
export default ImageSelector;
